import { makeRequest } from "./request";

export type GetOrganizationFileOptions = {
  organizationIdOverride?: string;
};

export type GetOrganizationFileResult = {
  objectUrl: string;
  revokeObjectUrl: () => void;
};

export const getOrganizationFile = async (organizationFileUrl: string): Promise<GetOrganizationFileResult> => {
  if (!organizationFileUrl) {
    throw new Error("File URL is required");
  }

  // Get signed url from API
  let signedUrl: string;
  try {
    const { pathname } = new URL(organizationFileUrl);
    const response = await makeRequest<{ signedUrl: string }>(`${pathname}?format=url`);
    if (!response.signedUrl) {
      throw new Error("Missing signed URL in response");
    }
    signedUrl = response.signedUrl;
  } catch (error) {
    throw new Error(`Failed to resolve organization file URL: ${(error as Error).message}`);
  }

  // Get file blob via signed url
  const blobResponse = await fetch(signedUrl);
  if (!blobResponse.ok) {
    throw new Error(`Failed to download organization file: ${blobResponse.status}`);
  }
  const blob = await blobResponse.blob();
  const objectUrl = URL.createObjectURL(blob);

  return {
    objectUrl,
    revokeObjectUrl: () => URL.revokeObjectURL(objectUrl),
  };
};
